import { TheoreticalValue } from 'components/quote/costsAndCharges/theoreticalValue';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { getRegulationInfos } from 'state/quotes/regulations/regulation.selectors';
import {
  getIsUserInternal,
  getQuoteIsTheoreticalValueRequired,
  getQuoteRegulationThoreticalValue,
} from 'state/selectors';
import type { AppState } from 'state/state.model';

import { RegulatoryComponentWrapper } from './Components';

interface TheoreticalValueRegulatoryPropsProps {
  tabId: string;
  quoteId: string;
}

export const TheoreticalValueRegulatory: FC<TheoreticalValueRegulatoryPropsProps> = ({ tabId, quoteId }) => {
  const intl = useIntl();
  const isTheoreticalValueRequired = useSelector((state: AppState) => getQuoteIsTheoreticalValueRequired(state, tabId));
  const regulationInfos = useSelector((state: AppState) => getRegulationInfos(state, tabId, quoteId));
  const thoreticalValue = useSelector((state: AppState) => getQuoteRegulationThoreticalValue(state, tabId, quoteId));
  const isInternalUser = useSelector((state: AppState) => getIsUserInternal(state));
  const isLoading = regulationInfos?.costAndChargeReceived !== true;
  const isError = !isLoading && thoreticalValue === undefined;

  if (!isTheoreticalValueRequired) {
    return null;
  }
  return (
    <RegulatoryComponentWrapper
      componentId="theoretical-value-accordion"
      title={isInternalUser ? 'costAndCharge.theoreticalValue.title.full' : 'costAndCharge.theoreticalValue.title'}
      isLoading={isLoading}
      isInError={isError}
      errorMessage={isError ? intl.formatMessage({ id: 'quote.errorMessages.TechnicalError' }) : undefined}
    >
      {thoreticalValue && <TheoreticalValue value={thoreticalValue} />}
    </RegulatoryComponentWrapper>
  );
};
